import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
export type FaqDTO =  {
    id:string;
    question:string;
    answer:string;
    video?:string;
    createdAt?:string;
    updatedAt?:string
}

interface CoursesData {
    faqData: FaqDTO[];
}
interface FaqResponse {
    data?: CoursesData;
    error?: ApiError;
}

export const getFAQ = async (): Promise<FaqResponse> => {
    try {
        const response = await axios.get("/faq/all");
        return { data: { faqData: response.data } };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};